import { Icon, Tooltip } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import { formatInternational } from 'lib-shared-phone-numbers';
import { memo } from 'react';

import { getPhoneNumberCountry } from 'utils/countries';

type PropTypes = {
  number: any;
  className: string;
  disabled: boolean;
  changeFromNumber: (payload: any) => void;
  index: number;
};

const NumberItem = ({
  number,
  className,
  disabled,
  changeFromNumber,
  index,
}: PropTypes) => {
  let numberLabel: JSX.Element | null = null;
  let recordLabel: JSX.Element | null = null;

  const phoneNumberFormat =
    formatInternational(number.e164_format) || number.e164_format;
  const countryCode = getPhoneNumberCountry(number);

  if (
    number.name !== undefined &&
    number.name !== null &&
    typeof number.name === 'string'
  ) {
    numberLabel = (
      <Tooltip content={number.name}>
        <em> ({number.name})</em>
      </Tooltip>
    );
  }

  if (number.record_outbound_calls && number.record_outbound_calls === true) {
    recordLabel = (
      <Tooltip
        content={`Outbound call recording is active on ${phoneNumberFormat}`}
      >
        <em className="recording-outbound">
          <Icon name="rec" />
        </em>
      </Tooltip>
    );
  }

  return (
    <li
      role="presentation"
      aria-disabled={disabled}
      className={classNames(className, ' menuitem', { disabled })}
      key={index}
      style={{ cursor: 'pointer' }}
    >
      <a
        href="#"
        role="menuitem"
        tabIndex={-1}
        onClick={(event) => {
          if (disabled) {
            event.preventDefault();
          }

          if (disabled) {
            return;
          }

          changeFromNumber(number);
        }}
      >
        <div className={`flag ${countryCode ?? 'unknown'}`}></div>
        <span className="number">
          {phoneNumberFormat} {numberLabel}
        </span>
        {recordLabel}
      </a>
    </li>
  );
};

export default memo(NumberItem);
